// DonationFormModal.jsx
import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
// import "./DonationFormModal.css"; // or reuse CharitiesManager.css

export default function DonationFormModal({
                                              charityId,
                                              lodges,              // [{ value, label }]
                                              donation = null,     // existing donation row
                                              onCancel,
                                              onSaved,             // (rowFromApi) => void
                                          }) {
    const today = new Date().toISOString().slice(0, 10);

    const [form, setForm] = useState({
        lodge_id: "",
        donated_on: today,
        amount: "",
        contribution_summary: "",
        source: "",
        notes: "",
    });
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (donation) {
            setForm({
                lodge_id: donation.lodge_id || "",
                donated_on: donation.donated_on || today,
                amount: donation.amount_cents
                    ? (Number(donation.amount_cents) / 100).toFixed(2)
                    : donation.amount || "",
                contribution_summary: donation.contribution_summary || "",
                source: donation.source || "",
                notes: donation.notes || "",
            });
        } else {
            setForm({
                lodge_id: "",
                donated_on: today,
                amount: "",
                contribution_summary: "",
                source: "",
                notes: "",
            });
        }
    }, [donation, today]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.lodge_id || !form.donated_on) {
            alert("Lodge and date are required.");
            return;
        }

        const amountText = String(form.amount || "").trim();
        const contributionText = String(form.contribution_summary || "").trim();
        if (!amountText && !contributionText) {
            alert("Enter an amount or a non-cash contribution summary.");
            return;
        }

        const amountNumber = amountText ? parseFloat(amountText) : null;
        if (amountText && (Number.isNaN(amountNumber) || amountNumber < 0)) {
            alert("Amount must be a positive number.");
            return;
        }

        const payload = {
            lodge_id: form.lodge_id,
            donated_on: form.donated_on,
            amount_cents: amountNumber === null ? null : Math.round(amountNumber * 100),
            contribution_summary: contributionText || null,
            source: form.source || null,
            notes: form.notes || null,
        };

        try {
            setSaving(true);
            let res;
            if (donation?.id) {
                res = await axios.put(
                    `/api/resources/charities/${charityId}/donations/${donation.id}`,
                    payload
                );
            } else {
                res = await axios.post(
                    `/api/resources/charities/${charityId}/donations`,
                    payload
                );
            }
            onSaved?.(res.data);
        } catch (err) {
            console.error(err);
            alert("Failed to save donation.");
        } finally {
            setSaving(false);
        }
    };

    const lodgeOption =
        lodges.find((l) => String(l.value) === String(form.lodge_id)) || null;

    return (
        <div
            className="dfm-overlay"
            onMouseDown={(e) => e.target === e.currentTarget && onCancel?.()}
        >
            <div className="dfm-dialog">
                <header className="dfm-header">
                    <h2>{donation ? "Edit Donation" : "Add Donation"}</h2>
                    <button className="dfm-close" onClick={onCancel}>
                        ×
                    </button>
                </header>

                <form className="dfm-body" onSubmit={handleSubmit}>
                    <div className="dfm-grid">
                        <label>
                            <span>Lodge*</span>
                            <Select
                                classNamePrefix="rs"
                                options={lodges}
                                value={lodgeOption}
                                placeholder="Choose lodge or entity…"
                                onChange={(o) =>
                                    setForm((f) => ({ ...f, lodge_id: o?.value || "" }))
                                }
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (b) => ({ ...b, zIndex: 2147483647 }),
                                }}
                            />
                        </label>

                        <label>
                            <span>Date*</span>
                            <input
                                type="date"
                                value={form.donated_on}
                                onChange={(e) =>
                                    setForm((f) => ({ ...f, donated_on: e.target.value }))
                                }
                            />
                        </label>

                        <label>
                            <span>Amount (ZAR)</span>
                            <input
                                type="number"
                                step="0.01"
                                min="0"
                                value={form.amount}
                                onChange={(e) =>
                                    setForm((f) => ({ ...f, amount: e.target.value }))
                                }
                            />
                        </label>

                        <label>
                            <span>Contribution</span>
                            <input
                                value={form.contribution_summary}
                                placeholder="25 soup jars, blankets, bursary support..."
                                onChange={(e) =>
                                    setForm((f) => ({ ...f, contribution_summary: e.target.value }))
                                }
                            />
                        </label>

                        <label>
                            <span>Source</span>
                            <input
                                value={form.source}
                                placeholder="Collection, transfer, raffle, estate, etc."
                                onChange={(e) =>
                                    setForm((f) => ({ ...f, source: e.target.value }))
                                }
                            />
                        </label>

                        <label className="span-2">
                            <span>Notes</span>
                            <textarea
                                rows={2}
                                value={form.notes}
                                placeholder="Purpose, reference, donor notes, restrictions, or report comments"
                                onChange={(e) =>
                                    setForm((f) => ({ ...f, notes: e.target.value }))
                                }
                            />
                        </label>
                    </div>

                    <footer className="dfm-footer">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={saving}
                        >
                            {saving ? "Saving…" : donation ? "Save" : "Add"}
                        </button>
                        <button
                            type="button"
                            className="btn btn-ghost"
                            onClick={onCancel}
                            disabled={saving}
                        >
                            Cancel
                        </button>
                    </footer>
                </form>
            </div>
        </div>
    );
}
